import React, { useMemo } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  MenuItem
} from "@mui/material";
import { useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useCreateGameLocationMutation,useGetGameQuery,useGetLocationQuery, } from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { IGameLocation, IPrinter, IGame, ILocation } from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import moment from "moment-timezone";

interface IGameLocationpopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  data?: IGameLocation;
}

const Coursing = ({
  openModel = false,
  handleCloseDialog,
  data,
}: IGameLocationpopup) => {
  const classes = useStyles();
  const [open] = React.useState(openModel);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { data: gamesData } = useGetGameQuery({ searchText: ""});
  const { data: locationsData } = useGetLocationQuery({ searchText: "",});
  const [newLocation, { isLoading }] = useCreateGameLocationMutation();
  const { showErrorMessage, showMessage } = useNotifier();
  
  const handleClose = () => {
    handleCloseDialog(false);
  };

const games: IGame[] = Array.isArray(gamesData?.data)
        ? (gamesData?.data as IGame[])
        : [];
  
const locations: ILocation[] = Array.isArray(locationsData?.data)
            ? (locationsData?.data as ILocation[])
            : [];

  const formik = useFormik({
  initialValues: {
    id: data?.id ,
    game_id: data?.game?.id || "",
    location_id: data?.location?.id || "",
    isActive: data?.isActive ? Boolean(data?.isActive) : true,
    },
    onSubmit: async (values) => {
      try {
       
         const temData = {
  id: values?.id,
  game_id: values.game_id,
  location_id: values.location_id,
  isActive: Boolean(values.isActive),
};
    
        if (!data) {
          delete values.id;
        }

        const addCompanyResponse = await newLocation(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          handleClose();
         // console.log((addCompanyResponse.data as IGame).id);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });


    const formValid = useMemo(() => {
            return formik.values.game_id  === "" &&
              formik.values.game_id  === undefined &&
              formik.values.location_id   === "" &&
              formik.values.location_id   === undefined 
   
              ? false
              : true;
          }, [formik]);
    

  const gridHeight = isMobile ? "30px" : "400px";

  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          maxWidth: "1700px",
        },
      }}
    >
      <Grid className={classes.Dialog}>
        <Grid container spacing={3}>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                    Edit Game
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={9} md={9} sm={12} xs={12}>
            <form onSubmit={formik.handleSubmit}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Location Information
                        </Typography>
                      </Grid>
                    </Grid>

                       <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                                                 <Typography variant="subtitle1">
                                                    Game <span style={{ color: "red" }}>*</span>
                                                 </Typography>
                                               </Grid>
                                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                                   <TextField
                                               select
                                               fullWidth
                                               size="small"
                                               {...formik.getFieldProps("game_id")}
                                               className={classes.textField}
                                             >
                                               <MenuItem value="">Select Game</MenuItem>
                                               {games?.map((game: IGame) => (
                                                 <MenuItem key={game.id} value={game.id}>
                                                   {game.name}
                                                 </MenuItem>
                                               ))}
                                             </TextField>
                                               </Grid>
                                             </Grid>
                                           </Grid>
                       
                                          
                       <Grid item lg={6} md={6} sm={12} xs={12}>
                         <Grid container alignItems="center">
                           <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Typography variant="subtitle1">Location <span style={{ color: "red" }}>*</span></Typography>
                           </Grid>
                           <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                               select
                                               fullWidth
                                               size="small"
                                               {...formik.getFieldProps("location_id")}
                                               className={classes.textField}
                                             >
                                               <MenuItem value="">Select Location</MenuItem>
                                               {locations?.map((location: ILocation) => (
                                                 <MenuItem key={location.id} value={location.id}>
                                                   {location.name}
                                                 </MenuItem>
                                               ))}
                                             </TextField>
                           </Grid>
                         </Grid>
                       </Grid>
                          

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Active</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <CustomSwitch
                            color="primary"
                            sx={{ mr: 2 }}
                            formik={formik}
                            name="isActive"
                          />
                        </Grid>
                      </Grid>
                    </Grid>


                    </Grid>
                  </Card>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<SaveAltIcon />}
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                          disabled={!formValid || isLoading}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default Coursing;
